<template>
<!-- <newPlant ref="newPlant" @AfterNew="getList()"></newPlant> -->
<Window :id="'newPlant'" :title="title" ref="Window" @Closed="$emit('Close')">
	<!-- <Confirm ref="confirm" :title="' '"></Confirm> -->
	<div slot="headButton" class="fR cb tra-fast_E ml05x_E">
		<button v-if="step==1||myMode=='edit'" class="bdSub boxR hover-bg-highLight" @click="Close">{{$t('cmd85',['取消'])}}</button>
		<!-- <button v-if="step>2" class="bdSub boxR hover-bg-highLight" :class="{disable:lock.newPlant}">{{$t('cmd75',['上一步'])}}</button> -->
		<!-- <button v-if="step<stepMax&&myMode=='new'" class="bdSub boxR hover-main" :class="{disable:lock.newPlant}" @click="nextStep(data)">{{$t('cmd11',['下一步'])}}</button> -->
		<!-- <button v-if="step==1" class="functionBtn" :class="{disable:lock.newPlant}" @click="newPlant(data)">{{$t('cmd24',['完成'])}}</button> -->
		<!-- <button v-if="myMode=='new' && step==2 && moreBtnFlag" class="bdSub boxR hover-bg-highLight close" :class="{disable:lock.newPlant}" @click="step2Skip" type="button">{{$t('',['不用，下次再说'])}}</button> -->
		<button v-if="myMode=='new'" class="functionBtn" :class="{disable:lock.newPlant}" @click="onStep" type="button">{{(step<2)? $t('cmd84',['保存']):$t('cmd24',['完成'])}}</button>
		<button v-if="myMode=='edit'" class="functionBtn" :class="{disable:lock.newPlant}" @click="onStep" type="button">{{$t('cmd24',['完成'])}}</button>
	</div>
	<div v-show="step==1" class="w60pct mc posR">
		<div class="quickNav mt2x bdSub-right lh20 cField hover-c-main_E tra-fast_E boxR_E">
			<button type="button">{{getLanguageStr('word1642','基础信息')}}</button>
			<button type="button">{{getLanguageStr('word1718','系统信息')}}</button>
			<button type="button">{{getLanguageStr('word1702','收益信息')}}</button>
			<button type="button">{{getLanguageStr('word731','业主信息')}}</button>
			<button type="button" v-if="hideIn3rd">{{getLanguageStr('word1277',['电价和补贴'])}}</button>
			<button type="button" v-if="hideIn3rd">{{getLanguageStr('assess14',['融资信息'])}}</button>
		</div>
	</div>
	<div fillHeight="window,-#newPlant .head,-space,-space" scroll>
		<!--
		<div v-show="myMode=='new'" class="w30pct stepSys stepSys-blue mt2x mb1x mc">
			<div class="tableSys">
				<div class="step" :class="{active: 1 <= step,peN:myMode=='new'}">
					<button @click="step=1"><span class="num">1</span><div class="name">{{$t('word733',['电站信息'])}}</div></button>
				</div>
				<div></div>
				<div class="step" :class="{active: 2 <= step,peN:myMode=='new'}">
					<button @click="step=2"><span class="num">2</span><div class="name">{{$t('manage76',['成员'])}}</div></button>
				</div>
				<div></div>
				<div class="step" :class="{active: 3<=step,peN:myMode=='new'}">
					<button @click="step=3"><span class="num">3</span><div class="name">{{getLanguageStr('device224','添加设备')}}</div></button>
				</div>
			</div>
			<div class="stepBar" :step="progress"></div>
		</div>

		 -->
		<div v-show="step==1" class="w60pct mc mt2x mb1x">
			<TagForm :title="getLanguageStr('word1642','基础信息')" :ctrlBtn="false">
				<!--
				<table>
					<thead class="head-token">
						<tr>
							<th></th>
							<td></td>
							<th></th>
							<td></td>
						</tr>
					</thead>
					<tbody>
						<tr>
							<th class="cSub" :title="getLanguageStr('creat_plant17','电站名称')"><span class="cWarning">* </span>{{getLanguageStr('creat_plant17','电站名称')}}</th>
							<td colspan="3">
								<InputText v-model="data.station.name" :verification="'notEmpty'" :max-length="255" ref="plantName"></InputText>
							</td>
						</tr>
						<tr>
							<th class="cSub" :title="$t('word758',['电站位置'])"><span class="cWarning">* </span>{{$t('word758',['电站位置'])}}</th>
							<td class="vaM_E" colspan="3">
								<SearchPosition :location="data.station.location" @Update="updatePosition" ref="SearchPosition"></SearchPosition>
							</td>
						</tr>
						<tr>
							<th class="cSub" :title="getLanguageStr('word767','电站时区')">{{getLanguageStr('word767','电站时区')}}</th>
							<td class="vaM_E">
								<Select :list="timeZoneList" :bindActive="data.station.region.timezone" @Click="$set(data.station.region,'timezone',timeLimit[arguments[0]].value)" :size="'m'" class="w100pct"></Select>
							</td>
							<th class="cSub" :title="$t('word849',['联系电话'])">{{$t('word849',['联系电话'])}}</th>
							<td><InputText v-model="data.station.contactPhone" :only="'tel'" :maxLength="20"></InputText></td>
						</tr>
					</tbody>
				</table>
				 -->
				 <ul class="w44pct_E dpIB_E mt2x_E vaT_E">
					<li class="w100pct">
						<div class="cSub mb1x" :title="getLanguageStr('creat_plant17','电站名称')"><span class="cWarning">* </span>{{getLanguageStr('creat_plant17+: ','电站名称: ')}}</div>
						<InputText v-model="data.station.name" :verification="'notEmpty'" ref="plantName" name="stationName"></InputText>
					</li>
					<li class="w100pct">
						<div class="cSub mb1x" :title="$t('word758',['电站位置'])"><span class="cWarning">* </span>{{getLanguageStr('word758+: ','电站位置: ')}}</div>
						<SearchPosition :isEdit='isEdit' :location="data.station.location" :defaultRegion='dataBack.station.region' @Update="updatePosition" ref="SearchPosition"></SearchPosition>
					</li>
					<li>
						<div class="cSub mb1x" :title="getLanguageStr('word767','电站时区')">{{getLanguageStr('word767+: ','电站时区: ')}}</div>
						<Select :list="timeZoneList" v-model="data.station.region.timezone" :bindActive="data.station.region.timezone" :keyMap="{text:'displayName',value:'code'}" :size="'m'" class="w100pct"></Select>
					</li>

					<li class="ml10pct">
						<div class="mb1x" :title="getLanguageStr('word772','建站时间')">{{getLanguageStr('word772+: ','建站时间: ')}}</div>
						<div>{{timeFormat(this.mode=='new'?Date.parse(data.station.createdDate)/1000:data.station.createdDate,"utc","%Y/%m/%d")}}</div>
						<!-- <vue-datepicker-local v-model="data.station.createdDate" class="sizeM" :disabled-date="disabledDate"></vue-datepicker-local> -->
					</li>

				 </ul>

			</TagForm>

			<TagForm :title="getLanguageStr('word1718','系统信息')" :ctrlBtn="false">
				<!--
				<table>
					<tbody>
						<tr>
							<th class="cSub" :title="getLanguageStr('word728','电站类型')">{{getLanguageStr('word728','电站类型')}}</th>
							<td>
								<label v-for="plant in getTypeText('','plantType',true)" :key="plant.id[0]" class="mr1x"><input type="radio" name="plantType" v-model="data.station.type" :value="plant.id[0]">{{plant.name}}</label>
							</td>
						</tr>
						<tr>
							<th class="cSub" :title="getLanguageStr('word736','并网类型')">{{getLanguageStr('word736','并网类型')}}</th>
							<td>
								<label v-for="plant in getTypeText('','plantGridType',true)" :key="plant.id[0]" class="mr1x"><input type="radio" name="plantGridType" v-model="data.station.gridInterconnectionType" :value="plant.id[0]">{{plant.name}}</label>
							</td>
						</tr>
						<tr>
							<th class="cSub" :title="getLanguageStr('word727+(+unit11+)','装机容量(kWp)')">{{getLanguageStr('word727+(+unit11+)','装机容量(kWp)')}}</th>
							<td><InputText class="w50pct" v-model="data.station.installedCapacity" :default="data.station.installedCapacity" :only="'absNumber'" :matchType="'floor2x'" :verification="'<=:1000000000'"></InputText></td>
						</tr>
						<tr v-if="data.station.gridInterconnectionType==getTypeText('','plantGridType',true)[1].id[0]">
							<th class="cSub" :title="getLanguageStr('word1279','理论自发自用率量')">{{getLanguageStr('word1279','理论自发自用率量(%)')+"(%)"}}</th>
							<td><InputText class="w50pct" v-model="data.metering.theoryConsumeProportion" :default="data.metering.theoryConsumeProportion" :only="'absNumber'" :matchType="'floor2x'"" :verification="'<=:100'"></InputText></td>
						</tr>
						<tr>
							<th class="cSub" :title="getLanguageStr('word770+(+unit12+)','方位角(°)')">{{getLanguageStr('word770+(+unit12+)','方位角(°)')}}</th>
							<td><InputText class="w50pct" v-model="data.station.installationAzimuthAngle" :default="data.station.installationAzimuthAngle" :only="'absNumber'" :matchType="'floor2x'" :verification="'<=:360'"></InputText></td>
						</tr>
						<tr>
							<th class="cSub" :title="getLanguageStr('word759+(+unit12+)','倾角(°)')">{{getLanguageStr('word759+(+unit12+)','倾角(°)')}}</th>
							<td><InputText class="w50pct" v-model="data.station.installationTiltAngle" :default="data.station.installationTiltAngle" :only="'absNumber'" :matchType="'floor2x'" :verification="'<=:90'"></InputText></td>
						</tr>
						<tr>
							<th class="cSub" :title="getLanguageStr('word1280','并网时间')">{{getLanguageStr('word1280','并网时间')}}</th>
							<td><vue-datepicker-local v-model="data.station.startOperatingTime"  class="sizeM"></vue-datepicker-local></td>
						</tr>
					</tbody>
				</table>
				 -->
				 <ul class="w44pct_E dpIB_E mt2x_E vaT_E">
					<li>
						<div class="cSub mb1x" :title="getLanguageStr('word728','电站类型')">{{getLanguageStr('word728+: ','电站类型: ')}}</div>
							<Select :name="'plantType'" :list=" getTypeText('','plantType',true)" v-model="data.station.type" :bindActive="data.station.type" :keyMap="{text:'name',value:'value'}"></Select>
						<!--<label v-for="plant in getTypeText('','plantType',true)" :key="plant.id[0]" class="dpIB mr1x mb05x"><input type="radio" name="plantType" v-model="data.station.type" :value="plant.id[0]">{{plant.name}}</label>-->
					</li>
					<li class="ml10pct">
						<div class="cSub mb1x" :title="getLanguageStr('word736','并网类型')">{{getLanguageStr('word736+: ','并网类型: ')}}</div>
						<Select :name="'plantGridType'" :list=" getTypeText('','plantGridType',true)" v-model="data.station.gridInterconnectionType" :bindActive="data.station.gridInterconnectionType" :keyMap="{text:'name',value:'value'}" @click="showChangeTip('gridType')"></Select>
					<!--	<label v-for="plant in getTypeText('','plantGridType',true)" :key="plant.id[0]" class="dpIB mr1x mb05x" @click="showChangeTip('gridType')"><input type="radio" name="plantGridType" v-model="data.station.gridInterconnectionType" :value="plant.id[0]">{{plant.name}}</label>-->
						<div v-if="myMode=='edit'&&changeTip.gridType&&changeTip.sourceFrom" class="cWarning mt05x lh13">{{$t('phrase550',['你已修改并网类型，系统将重新选择电站的最优数据来源并重新计算电站数据（数据更新需要5~10分钟的时间），这不会影响历史数据但可能导致电站数据与修改前不一致，建议你在修改并网类型后，在“电站设置-数据来源”中选择最符合电站实际情况的数据来源。'])}}</div>
					</li>
					<li>
						<div class="cSub mb1x" :title="getLanguageStr('word727','装机容量(kWp)')+'(kWp)'"><span class="cWarning">* </span>{{getLanguageStr('word727','装机容量(kWp): ')}}(kWp): </div>
						<InputText class="w100pct" v-model="data.station.installedCapacity" name="installedCapacity" :default="data.station.installedCapacity" :only="'absNumber'" maxLength='12' :matchType="'floor2x'" :outType="'number'" :verification="'~:0.01~100000000'" ref="installedCapacity"></InputText>
					</li>
					<li class="ml10pct">
						<div class="cSub mb1x" :title="getLanguageStr('word770','方位角(°)')+'(°)'">{{getLanguageStr('word770','方位角(°): ')}}(°): </div>
						<InputText class="w100pct" v-model="data.station.installationAzimuthAngle" placeholder='0~360' name="installationAzimuthAngle" :default="data.station.installationAzimuthAngle" :only="'absNumber'" :matchType="'floor2x'" :outType="'number'" :verification="'<=:360'" ref="installationAzimuthAngle"></InputText>
					</li>
					<li>
						<div class="cSub mb1x" :title="getLanguageStr('word759','倾角(°)')+'(°)'">{{getLanguageStr('word759','倾角(°): ')}}(°): </div>
						<InputText class="w100pct" v-model="data.station.installationTiltAngle" placeholder='0~90' name="installationTiltAngle" :default="data.station.installationTiltAngle" :only="'absNumber'" :matchType="'floor2x'" :outType="'number'" :verification="'<=:90'" ref="installationTiltAngle"></InputText>
					</li>
					<li class="ml10pct">
						<div class="cSub mb1x vaM_E">
							<span :title="getLanguageStr('word2006','投产日期(并网日期或开始发电日期)')">{{getLanguageStr('word2006','投产日期(并网日期或开始发电日期)')}}: </span>
							<Help :code="'startTime'" :btnClose="false" class="ml05x posA"></Help>
						</div>
						<vue-datepicker-local v-model="data.station.startOperatingTime" :disabled-date="startDate" @input="returnStartOpTime" class="sizeM"></vue-datepicker-local>
					</li>
					<li v-if="!['DISTRIBUTED_FULLY','CENTRALIZED_FULLY'].includes(data.station.gridInterconnectionType)" >
						<div class="cSub mb1x" :title="getLanguageStr('word1477','计划自发自用率')">{{getLanguageStr('word1477+: ','计划自发自用率(%)')+"(%): "}}</div>
						<InputText class="w100pct" v-model="data.metering.theoryConsumeProportion" placeholder='0~100%' name="theoryConsumeProportion" :default="data.metering.theoryConsumeProportion" :only="'absNumber'" :matchType="'floor2x'" :outType="'number'" :verification="'<=:100'" ref="theoryConsumeProportion"></InputText>
					</li>
				 </ul>
			</TagForm>
		<TagForm  :title="getLanguageStr('word1702',['收益信息'])" :ctrlBtn="false">
			<ul class="w44pct_E dpIB_E mt2x_E vaT_E">
				 <li >
					<div class="cSub mb1x" :title="$t('word1555',['货币单位'])"><span class="cWarning">* </span>{{getLanguageStr('word1555+: ','货币单位')}}</div>
						<Select :list="currencyList" v-model="data.finance.currency" @Click='changeC' :bindActive="data.finance.currency" :size="'m'" class="w100pct" :keyMap="{text:'displayName',value:'code'}" :verification="'notEmpty'" ref="currencySelect"></Select>
					</li>
						<li class="ml10pct">
						<div class="cSub mb1x" :title="getLanguageStr('plant_detail283','度电收益')">{{getLanguageStr('plant_detail283','度电收益')}}({{data.finance.currency=='CNY'&&stage.languageId=='zh'?'元':data.finance.currency}}/kWh)</div>
						<InputText class="w100pct" v-model="data.finance.mergeElectricPrice" :only="'absNumber'" :matchType="'floor2x'" :outType="'number'" maxLength='12'></InputText>
					</li>
						<li>
						<div v-if="data.finance.currency=='CNY' && stage && stage.languageId=='zh'" class="cSub mb1x" :title="getLanguageStr('word1281','总成本(元)')">{{getLanguageStr('word1281','总成本(元)')}}({{data.finance.currency=='CNY'&&stage.languageId=='zh'?'元':data.finance.currency}})</div>
						<div v-else class="cSub mb1x" :title="getLanguageStr('word1281','总成本')">{{getLanguageStr('word1281','总成本')}}({{data.finance.currency=='CNY'&&stage.languageId=='zh'?'元':data.finance.currency}}):</div>
						<InputText class="w100pct" v-model="data.finance.constructionCost" name="constructionCost" :default="data.finance.constructionCost" :matchType="'floor2x'" :outType="'number'" maxLength='12' :verification="'~:0.01~100000000'" :only="'absNumber'"></InputText>
					</li>
				</ul>
			</TagForm>
			<TagForm  :title="getLanguageStr('word731',['业主信息'])" :ctrlBtn="false">
				<ul class="w44pct_E dpIB_E mt2x_E vaT_E">
					<li class="cSub mb1x">
						<div class="cSub mb1x" :title="$t('word1704',['业主姓名'])">{{getLanguageStr('word1704+: ','业主姓名: ')}}</div>
						<InputText v-model="data.station.ownerName"  :maxLength="50" name="ownerName"></InputText>
					</li>
						<li class="ml10pct">
						<div class="cSub mb1x" :title="$t('word1617',['业主联系电话'])">{{getLanguageStr('word1617+: ','业主联系电话: ')}}</div>
						<InputText v-model="data.station.contactPhone" :only="'tel'" :maxLength="20" name="stationContactPhone"></InputText>
					</li>
					<li class="cSub mb1x">
						<div class="cSub mb1x" :title="$t('word1705',['业主工作单位'])">{{getLanguageStr('word1705+: ','业主工作单位: ')}}</div>
						<InputText v-model="data.station.ownerCompany"  :maxLength="50" name="ownerCompany"></InputText>
					</li>
				</ul>
			</TagForm>
			<TagForm v-if="hideIn3rd" :title="getLanguageStr('word1277',['电价和补贴'])" :ctrlBtn="false">
				<!--
				<table>
					<tbody>
						<tr v-if="data.station.gridInterconnectionType==getTypeText('','plantGridType',true)[0].id[0]">
							<th class="cSub" :title="getLanguageStr('word1142+(+CNY/+unit10+)','标杆电价(CNY/kWh)')">{{getLanguageStr('word1142+(+CNY/+unit10+)','标杆电价(CNY/kWh)')}}</th>
							<td><InputText class="w50pct" v-model="data.finance.benchmarkPrice" :default="data.finance.benchmarkPrice" :only="'absNumber'" :matchType="'floor2x'" :verification="'<=:1000000000'"></InputText></td>
						</tr>
						<tr v-if="data.station.gridInterconnectionType==getTypeText('','plantGridType',true)[1].id[0]">
							<th class="cSub" :title="getLanguageStr('word761+(+CNY/+unit10+)','平均用电电价(CNY/kWh)')">{{getLanguageStr('word761+(+CNY/+unit10+)','平均用电电价(CNY/kWh)')}}</th>
							<td><InputText class="w50pct" v-model="data.finance.consumptionPrice" :default="data.finance.consumptionPrice" :only="'absNumber'" :matchType="'floor2x'" :verification="'<=:1000000000'"></InputText></td>
						</tr>
						<tr v-if="data.station.gridInterconnectionType==getTypeText('','plantGridType',true)[1].id[0]">
							<th class="cSub" :title="getLanguageStr('word763+(+CNY/+unit10+)','脱硫上网电价(CNY/kWh)')">{{getLanguageStr('word763+(+CNY/+unit10+)','脱硫上网电价(CNY/kWh)')}}</th>
							<td><InputText class="w50pct" v-model="data.finance.desulfurizationPrice" :default="data.finance.desulfurizationPrice" :only="'absNumber'" :matchType="'floor2x'" :verification="'<=:1000000000'"></InputText></td>
						</tr>
						<tr v-if="data.station.gridInterconnectionType==getTypeText('','plantGridType',true)[1].id[0]">
							<th class="cSub" :title="getLanguageStr('word765+(+CNY/+unit10+)','发电国补(CNY/kWh)')">{{getLanguageStr('word765+(+CNY/+unit10+)','发电国补(CNY/kWh)')}}</th>
							<td class="vaM_E">
								<InputText class="w50pct dpIB mr1x" v-model="data.finance.nationalSubsidy.unitAmount" :default="data.finance.nationalSubsidy.unitAmount" :only="'absNumber'" :matchType="'floor2x'" :verification="'<=:1000000000'"></InputText>
								<span class="cSub mr05x">{{$t('word780',['年限'])}}</span>
								<Select :list="timeLimit" :bindActive="data.finance.nationalSubsidy.term" @Click="$set(data.finance.nationalSubsidy,'term',timeLimit[arguments[0]].value)" :size="'m'" class="w5x"></Select>
							</td>
						</tr>
						<tr>
							<th class="cSub" :title="getLanguageStr('word768+(+CNY/+unit10+)','发电省补(CNY/kWh)')">{{getLanguageStr('word768+(+CNY/+unit10+)','发电省补(CNY/kWh)')}}</th>
							<td class="vaM_E">
								<InputText class="w50pct dpIB mr1x" v-model="data.finance.provincialSubsidy.unitAmount" :default="data.finance.provincialSubsidy.unitAmount" :only="'absNumber'" :matchType="'floor2x'" :verification="'<=:1000000000'"></InputText>
								<span class="cSub mr05x">{{$t('word780',['年限'])}}</span>
								<Select :list="timeLimit" :bindActive="data.finance.provincialSubsidy.term" @Click="$set(data.finance.provincialSubsidy,'term',timeLimit[arguments[0]].value)" :size="'m'" class="w5x"></Select>
							</td>
						</tr>
						<tr>
							<th class="cSub" :title="getLanguageStr('word771+(+CNY/+unit10+)','发电市补(CNY/kWh)')">{{getLanguageStr('word771+(+CNY/+unit10+)','发电市补(CNY/kWh)')}}</th>
							<td class="vaM_E">
								<InputText class="w50pct dpIB mr1x" v-model="data.finance.prefecturalSubsidy.unitAmount" :default="data.finance.prefecturalSubsidy.unitAmount" :only="'absNumber'" :matchType="'floor2x'" :verification="'<=:1000000000'"></InputText>
								<span class="cSub mr05x">{{$t('word780',['年限'])}}</span>
								<Select :list="timeLimit" :bindActive="data.finance.prefecturalSubsidy.term" @Click="$set(data.finance.prefecturalSubsidy,'term',timeLimit[arguments[0]].value)" :size="'m'" class="w5x"></Select>
							</td>
						</tr>
						<tr>
							<th class="cSub" :title="getLanguageStr('word779+(+CNY/+unit10+)','发电县(区)补(CNY/kWh)')">{{getLanguageStr('word779+(+CNY/+unit10+)','发电县(区)补(CNY/kWh)')}}</th>
							<td class="vaM_E">
								<InputText class="w50pct dpIB mr1x" v-model="data.finance.countySubsidy.unitAmount" :default="data.finance.countySubsidy.unitAmount" :only="'absNumber'" :matchType="'floor2x'" :verification="'<=:1000000000'"></InputText>
								<span class="cSub mr05x">{{$t('word780',['年限'])}}</span>
								<Select :list="timeLimit" :bindActive="data.finance.countySubsidy.term" @Click="$set(data.finance.countySubsidy,'term',timeLimit[arguments[0]].value)" :size="'m'" class="w5x"></Select>
							</td>
						</tr>
						<tr>
							<th class="cSub" :title="getLanguageStr('word1281+(+CNY+)','总成本(CNY)')">{{getLanguageStr('word1281+(+CNY+)','总成本(CNY)')}}</th>
							<td><InputText class="w50pct" v-model="data.finance.constructionCost" :default="data.finance.constructionCost" :only="'absNumber'" :matchType="'floor2x'" :verification="'<=:1000000000'"></InputText></td>
						</tr>
						<tr>
							<th class="cSub" :title="getLanguageStr('word762+(+CNY+)','建设补贴(CNY)')">{{getLanguageStr('word762+(+CNY+)','建设补贴(CNY)')}}</th>
							<td><InputText class="w50pct" v-model="data.finance.constructionSubsidy" :default="data.finance.constructionSubsidy" :only="'absNumber'" :matchType="'floor2x'" :verification="'<=:1000000000'"></InputText></td>
						</tr>
					</tbody>
				</table>
				 -->
				<ul class="w44pct_E dpIB_E mt2x_E vaT_E">
					<li v-if="data.station.gridInterconnectionType==getTypeText('','plantGridType',true)[0].id[0]">
						<div class="cSub mb1x" :title="getLanguageStr('word1142+(+CNY/+unit10+)','标杆电价(CNY/kWh)')">{{getLanguageStr('word1142+(+CNY/+unit10+): ','标杆电价(CNY/kWh): ')}}</div>
						<InputText class="w100pct" v-model="data.finance.benchmarkPrice" name="benchmarkPrice" :default="data.finance.benchmarkPrice" :only="'absNumber'" :matchType="'floor2x'" :outType="'number'" :verification="'<=:1000000000'" ref="benchmarkPrice"></InputText>
					</li>
					<li v-if="data.station.gridInterconnectionType==getTypeText('','plantGridType',true)[1].id[0]">
						<div class="cSub mb1x" :title="getLanguageStr('word761+(+CNY/+unit10+)','平均用电电价(CNY/kWh)')">{{getLanguageStr('word761+(+CNY/+unit10+): ','平均用电电价(CNY/kWh): ')}}</div>
						<InputText class="w100pct" v-model="data.finance.consumptionPrice" name="consumptionPrice" :default="data.finance.consumptionPrice" :only="'absNumber'" :matchType="'floor2x'" :outType="'number'" :verification="'<=:1000000000'" ref="consumptionPrice"></InputText>
					</li>
					<li v-if="data.station.gridInterconnectionType==getTypeText('','plantGridType',true)[1].id[0]" class="ml10pct">
						<div class="cSub mb1x" :title="getLanguageStr('word763+(+CNY/+unit10+)','脱硫上网电价(CNY/kWh)')">{{getLanguageStr('word763+(+CNY/+unit10+): ','脱硫上网电价(CNY/kWh): ')}}</div>
						<InputText class="w100pct" v-model="data.finance.desulfurizationPrice" name="desulfurizationPrice" :default="data.finance.desulfurizationPrice" :only="'absNumber'" :matchType="'floor2x'" :outType="'number'" :verification="'<=:1000000000'" ref="desulfurizationPrice"></InputText>
					</li>
					<li v-if="data.station.gridInterconnectionType==getTypeText('','plantGridType',true)[1].id[0]">
						<div class="cSub mb1x" :title="getLanguageStr('word765+(+CNY/+unit10+)','发电国补(CNY/kWh)')">{{getLanguageStr('word765+(+CNY/+unit10+): ','发电国补(CNY/kWh): ')}}</div>
						<div class="vaM_E">
							<InputText class="w50pct dpIB mr1x" v-model="data.finance.nationalSubsidy.unitAmount" name="nationalSubsidyUnitAmount" :default="data.finance.nationalSubsidy.unitAmount" :only="'absNumber'" :matchType="'floor2x'" :outType="'number'" :verification="'<=:1000000000'" ref="nationalSubsidy"></InputText>
							<span class="cSub mr05x">{{getLanguageStr('word780+: ','年限: ')}}</span>
							<Select :list="timeLimit" :bindActive="data.finance.nationalSubsidy.term" @Click="$set(data.finance.nationalSubsidy,'term',timeLimit[arguments[0]].value)" :size="'m'" class="w5x"></Select>
						</div>
					</li>
					<li class="ml10pct">
						<div class="cSub mb1x" :title="getLanguageStr('word768+(+CNY/+unit10+)','发电省补(CNY/kWh)')">{{getLanguageStr('word768+(+CNY/+unit10+): ','发电省补(CNY/kWh): ')}}</div>
						<div class="vaM_E">
							<InputText class="w50pct dpIB mr1x" v-model="data.finance.provincialSubsidy.unitAmount" name="provincialSubsidyUnitAmount" :default="data.finance.provincialSubsidy.unitAmount" :only="'absNumber'" :matchType="'floor2x'" :outType="'number'" :verification="'<=:1000000000'" ref="provincialSubsidy"></InputText>
							<span class="cSub mr05x">{{getLanguageStr('word780+: ','年限: ')}}</span>
							<Select :list="timeLimit" :bindActive="data.finance.provincialSubsidy.term" @Click="$set(data.finance.provincialSubsidy,'term',timeLimit[arguments[0]].value)" :size="'m'" class="w5x"></Select>
						</div>
					</li>
					<li>
						<div class="cSub mb1x" :title="getLanguageStr('word771+(+CNY/+unit10+)','发电市补(CNY/kWh)')">{{getLanguageStr('word771+(+CNY/+unit10+): ','发电市补(CNY/kWh): ')}}</div>
						<div class="vaM_E">
							<InputText class="w50pct dpIB mr1x" v-model="data.finance.prefecturalSubsidy.unitAmount" name="prefecturalSubsidyUnitAmount" :default="data.finance.prefecturalSubsidy.unitAmount" :only="'absNumber'" :matchType="'floor2x'" :outType="'number'" :verification="'<=:1000000000'" ref="prefecturalSubsidy"></InputText>
							<span class="cSub mr05x">{{getLanguageStr('word780+: ','年限: ')}}</span>
							<Select :list="timeLimit" :bindActive="data.finance.prefecturalSubsidy.term" @Click="$set(data.finance.prefecturalSubsidy,'term',timeLimit[arguments[0]].value)" :size="'m'" class="w5x"></Select>
						</div>
					</li>
					<li class="ml10pct">
						<div class="cSub mb1x" :title="getLanguageStr('word779+(+CNY/+unit10+)','发电县(区)补(CNY/kWh)')">{{getLanguageStr('word779+(+CNY/+unit10+): ','发电县(区)补(CNY/kWh): ')}}</div>
						<div class="vaM_E">
							<InputText class="w50pct dpIB mr1x" v-model="data.finance.countySubsidy.unitAmount" name="countySubsidyUnitAmount" :default="data.finance.countySubsidy.unitAmount" :only="'absNumber'" :matchType="'floor2x'" :outType="'number'" :verification="'<=:1000000000'" ref="countySubsidy"></InputText>
							<span class="cSub mr05x">{{getLanguageStr('word780+: ','年限: ')}}</span>
							<Select :list="timeLimit" :bindActive="data.finance.countySubsidy.term" @Click="$set(data.finance.countySubsidy,'term',timeLimit[arguments[0]].value)" :size="'m'" class="w5x"></Select>
						</div>
					</li>
					<li>
						<div class="cSub mb1x" :title="getLanguageStr('word1281+(+CNY+)','总成本(CNY)')">{{getLanguageStr('word1281+(+CNY+): ','总成本(CNY): ')}}</div>
						<InputText class="w100pct" v-model="data.finance.constructionCost" name="constructionCost" :default="data.finance.constructionCost" :only="'absNumber'" :matchType="'floor2x'" :outType="'number'" :verification="'<=:1000000000'"></InputText>
					</li>
					<li class="ml10pct">
						<div class="cSub mb1x" :title="getLanguageStr('word762+(+CNY+)','建设补贴(CNY)')">{{getLanguageStr('word762+(+CNY+): ','建设补贴(CNY): ')}}</div>
						<InputText class="w100pct" v-model="data.finance.constructionSubsidy" name="constructionSubsidy" :default="data.finance.constructionSubsidy" :only="'absNumber'" :matchType="'floor2x'" :verification="'<=:1000000000'"></InputText>
					</li>
				</ul>
			</TagForm>

				<!--
			<TagForm :title="getLanguageStr('assess14',['融资信息'])" :ctrlBtn="false">
				<ul class="w44pct_E dpIB_E mt2x_E vaT_E">
					<li>
						<div class="cSub mb1x" :title="getLanguageStr('word1282','是否融资')">{{getLanguageStr('word1282+: ','是否融资: ')}}</div>
						<label class="mr1x"><input type="radio" name="financeSwitch" v-model="data.finance.financing" :value="true">{{$t('cmd76',['是'])}}</label>
						<label class="mr1x"><input type="radio" name="financeSwitch" v-model="data.finance.financing" :value="false" :checked="data.finance.financing!=true" @click="backToDefault('finance')">{{$t('cmd124',['否'])}}</label>
					</li>
					<li v-if="data.finance.financing" class="ml10pct">
						<div class="cSub mb1x" :title="getLanguageStr('word769','还款方式')">{{getLanguageStr('word769+: ','还款方式: ')}}</div>
							<label v-for="plant in getTypeText('','repaymentMethod',true)" :key="plant.id[0]" class="dpIB mr1x mb05x"><input type="radio" name="repaymentMethod" v-model="data.finance.financingRepaymentMethod" :value="plant.id[0]">{{plant.name}}</label>
					</li>
					<li v-if="data.finance.financing&&data.finance.financingRepaymentMethod!='RENTAL'">
						<div class="cSub mb1x" :title="getLanguageStr('plant305','融资比例(%)')">{{getLanguageStr('plant305','融资比例(%)')+"(%): "}}</div>
						<InputText class="w100pct" v-model="data.finance.financingProportion" name="financingProportion" :default="data.finance.financingProportion" :only="'absNumber'" :matchType="'floor2x'" :verification="'~:0.01~100'" ref="financingProportion"></InputText>
					</li>
					<li v-if="data.finance.financing&&data.finance.financingRepaymentMethod!='RENTAL'" class="ml10pct">
						<div class="cSub mb1x" :title="getLanguageStr('plant304','融资年利率(%)')">{{getLanguageStr('plant304','融资年利率(%)')+"(%): "}}</div>
						<div class="vaM_E">
							<InputText class="w50pct dpIB mr1x" v-model="data.finance.financingInterestRate" name="financingInterestRate" :default="data.finance.financingInterestRate" :only="'absNumber'" :matchType="'floor2x'" :verification="'~:0.01~100'" ref="financingInterestRate"></InputText>
							<span class="cSub mr05x">{{getLanguageStr('word780+: ','年限: ')}}</span>
							<Select :list="timeLimit120" :bindActive="data.finance.financingPeriod" @Click="$set(data.finance,'financingPeriod',timeLimit120[arguments[0]].value)" :size="'m'" :dir="'up'" class="w5x"></Select>
						</div>
					</li>
					<li v-if="data.finance.financing">
						<div class="cSub mb1x" :title="getLanguageStr('plant303','融资到期日')">{{getLanguageStr('plant303+: ','融资到期日: ')}}</div>
						<vue-datepicker-local v-model="data.finance.financingTerm"  class="sizeM"></vue-datepicker-local>
					</li>
					<li v-if="data.finance.financing&&data.finance.financingRepaymentMethod=='RENTAL'" class="ml10pct">
						<div class="mb1x">
							<span :title="getLanguageStr('plant306+: ','上传租金表文件: ')" class="cSub mr1x">{{getLanguageStr('plant306+: ','上传租金表文件: ')}}</span>
							<a href="/static/file/tpl/租金表模板.xlsx" target="_blank" class="tra-fast fa fa-download">{{getLanguageStr('plant307',['下载租金表模板'])}}</a>
						</div>
						<AddFile
							:file="data.finance.tariffUrl"
							:verification="'notEmpty:'+getLanguageStr('plant308','租金表明细不能为空')"
							:accept="'.xls,.xlsx,.csv'"
							@Upload="addFile(arguments[0],'finance')"
							@Remove="removeFile(arguments[0],'finance')"
							ref="addFile"
						></AddFile>
					</li>
				</ul>
			</TagForm>
				 -->
		</div><!--1 end-->
		<div v-show="step==2" class="w60pct mc lh15">
			<div class="mt2x fs16x bdLight-bottom pb1x">
				<span v-if="moreBtnFlag">{{$t('creat_plant5',['电站创建成功！你还可以进行如下操作'])}}</span>
				<span v-else>{{$t('creat_plant6',['电站创建成功！'])}}</span>
			</div>
			<div v-permissions="'A/B/A8'" permission-type="none" onclick="statistic('A23','A26')">
				<TagForm :title="getLanguageStr('word1779','添加新网关/采集器')"  :showDetail="Boolean(false)" :titleDesc="getLanguageStr('phrase641','输入属于该电站的直联设备序列号，电站将根据直联设备来统计电站数据。非必填项，你可以在电站详情中再次操作')" :ctrlBtn="false">
					<AddDevice :id="newPlantData.id" class="afterNew mt2x" @Update="updateDeviceList" ref="AddDevice" :type="'new'"></AddDevice>
				</TagForm>
			</div>
			<!-- 关联用户 -->
			<div v-permissions="'A/B/A17'" permission-type="none" onclick="statistic('A23','A53')">
				<TagForm :title="getLanguageStr('word1716','授权用户')"  :showDetail="Boolean(false)" :titleDesc="getLanguageStr('phrase734','将电站授权给用户，这样用户可以看到这个电站。非必填项，你可以在电站详情中再次操作。')" :ctrlBtn="false">
					 <RelevanceAccount ref="relevanceAccount" :stationId="[newPlantData.id]" @UpdateData="data=>usersList=data"></RelevanceAccount>
				</TagForm>
			</div>
			<!-- 关联商家 -->
			<div v-permissions="'A/B/A19'" permission-type="none">
				<TagForm :title="getLanguageStr('word297','授权商家')" @SizeCtrl="()=>{statistic('A23','A54')}" :showDetail="Boolean(false)" :titleDesc="getLanguageStr('phrase735','将电站授权给其他商家，这样其他商家也能看到这个电站。非必填项，你可以在电站详情中再次操作。')" :ctrlBtn="false">
					<RelevanceBusiness ref="RelevanceBusiness" :stationId="[newPlantData.id]" @UpdateData="data=>businessList = data"></RelevanceBusiness>
				</TagForm>
			</div>
			<div v-permissions="'A/B/A14'" permission-type="none">
				<TagForm :title="getLanguageStr('word1930','授权内部成员')" @SizeCtrl="()=>{statistic('A23','A55')}" :showDetail="Boolean(false)" :titleDesc="getLanguageStr('plant370','将电站授权给商家内部成员，你的同事也能看到这个电站。非必填项，你可以在电站详情中再次操作。')" :ctrlBtn="false">
					<!--<div class="">{{$t('phrase549',['请选择该电站的关联人，该步骤为非必填步骤，您可以在电站详情-更多操作中再次添加'])}}</div>-->
					<related-person class="afterNew w80pct mt2x" @Update="updatePersonList" ref="AddPerson" title=""></related-person>
				</TagForm>
			</div>
			<div v-permissions="'A/B/A16'" permission-type="none">
				<TagForm :title="getLanguageStr('cmd292',['选择标签'])" :showDetail="Boolean(false)" :titleDesc="getLanguageStr('phrase662','选择该电站所属标签，你可以通过标签来筛选电站，非必填项，你可以在电站详情中再次操作。')" :ctrlBtn="false">
					<!--<div class="">{{$t('phrase662',['选择该电站所属标签，你可以通过标签来筛选电站，非必填项，你可以在电站详情中再次操作。'])}}</div>-->
					<tag-manage-core ref="TagManageCore" @Update="list=>{tagList=list;}" :id="targetId"></tag-manage-core>
				</TagForm>
			</div>
			<div v-permissions="'A/B/A8'" permission-type="none">
				<TagForm :title="getLanguageStr('word1780','添加新子系统')" @SizeCtrl="()=>{statistic('A23','A56')}" :showDetail="Boolean(false)" :titleDesc="getLanguageStr('phrase663','添加该电站的子系统，你可以将设备加入到子系统中以此达到分别统计的目的，非必填项，你可以在电站详情中再次操作。')" :ctrlBtn="false">
					<!--<button class="hover-f-error hover-effect-rotate tra-fast fR" :key="'clear'" @click="clear" type="button"><div class="icoSys w1x h1x bgSub fSub fs16x"><Icon name="no" /></div></button>-->
					<div class="enableList mt05x bdSub boxR-light dpIB cb tra ml05x_E mt05x_E fL_E">
						<TagBox v-for="(tag,i) in subSysTagList" :key="tag.id" :styleType="'tag'" :val="tag.name" :data="tag" @Remove="deleteChildSys(tag,i)"></TagBox>
						<button :key="'add'" class="lh15 cMain" @click="_AddChildSys" type="button">{{'+'+getLanguageStr('cmd250',['添加子系统'])}}</button>
						<AddChildSys ref="AddChildSys" @update="addChildSys"></AddChildSys>
					</div>
				</TagForm>
			</div>
		</div>
	</div>
</Window>
</template>
<script>
import {mapGetters} from 'vuex'

import Loading from '@/components/common/ui/Loading'
import InputText from '@/components/common/ui/InputText.vue'
import TagForm from '@/components/common/ui/TagForm.vue'
import Select from '@/components/common/ui/Select.vue'
import Confirm from '@/components/common/ui/Confirm.vue'
import AddFile from '@/components/common/ui/AddFile.vue'
import AddDevice from '@/components/common/AddDevice/AddDevice.vue'
import TagManageCore from '@/components/common/tagManage/Core.vue'
import RelatedPerson from '@/view/maintain/light/plant/part/RelatedPerson'
import SearchPosition from '@/view/maintain/light/plant/part/SearchPosition.vue'
import TagBox from '@/components/common/ui/TagBox.vue'
import AddChildSys from '@/components/common/ChildSysConfig.vue'
import Help from '@/components/common/Help.vue'
import RelevanceAccount from '@/view/maintain/light/plant/relevance/RelevanceUser'
import RelevanceBusiness from '@/view/maintain/light/plant/relevance/RelevanceBusiness'

import * as lib from '@/util/lib.js'
import {getLanguageStr} from '@/util/language.js'

import Window from '@/components/common/ui/WindowForNew.vue'

import {dictListCurrency,dictListTimezone} from '@/api/base.js'
import {apiNewPlant, apiAddDevice, apiAddPerson, StationMetering, StationMeteringStrategy, DeleteChildSys, PostGateway} from '@/api/maintain/plant/list.js'
import {apiDeleteTag} from '@/api/manage/tag.js'
import {AddRelatedBus, AddRelatedUser} from '@/api/maintain/plant/relative.js'

export default {
	name: 'NewPlant',
	props: {
		mode: {
			type: String,
			default: 'new'
		}
	},
	components: {RelevanceAccount, RelevanceBusiness, Loading, InputText, TagForm, Select, Confirm, AddFile, AddDevice, TagManageCore, Window, RelatedPerson, SearchPosition, TagBox, AddChildSys, Help},
	data () {
		return {// 待提交的数据
			isEdit: false,
			lock: {
				newPlant: false
			},
			changeTip: {
				gridType: false,
				sourceFrom: true
			},
			stage,
			myMode: this.mode,
			targetId: '', // 修改需要对应id
			hideIn3rd: false,
			subSysTagList: [],
			tagList: [],
			data: {
				'finance': {
					'financing': false, // 是否融资
					'benchmarkPrice': 0, // 标杆电价
					'constructionCost': 0, // 总成本
					// "constructionDate": "2018-06-20T11:56:11.707Z",
					'constructionSubsidy': 0, // 建设补贴
					'consumptionPrice': 0, // 平均用电电价
					'countySubsidy': {// 发电县补
						'term': 0,
						'unitAmount': 0
					},
					'currency': '', // 货币单位
					'desulfurizationPrice': 0, // 脱硫上网电价
					mergeElectricPrice:"",//度电收益
					// "financingAmount": 0,
					'financingInterestRate': 4.36, // 融资年利率
					'financingPeriod': 10, // 融资年利率年限
					'financingProportion': 90, // 融资比例
					'financingRepaymentMethod': lib.getTypeText('', 'repaymentMethod', true)[0].id[0], // 还款方式
					tariffUrl: '', // 租金表地址
					// "financingTerm":new Date(),//融资到期日
					'nationalSubsidy': {// 发电国补
						'term': 0,
						'unitAmount': 0
					},
					'powerStationId': 0,
					'prefecturalSubsidy': {// 发电市补
						'term': 0,
						'unitAmount': 0
					},
					'provincialSubsidy': {// 发电省补
						'term': 0,
						'unitAmount': 0
					}
				},
				'metering': {
					// "batteryMeterDeviceId": 0,
					// "batteryStatisticMethod": "PROPORTION",
					// "consumptionMeterDeviceId": 0,
					// "consumptionStatisticMethod": "数据采集并计算：INVERTER_SUM，理论自发自用比例：PROPORTION",
					// "generationMeterDeviceId": 0,
					// "generationStatisticMethod": "设备上传的累计发电量计算：TOTAL_FROM_DEVICE，每日发电量求和计算：TOTAL_DAILY_SUM",
					// "powerStationId": 0,
					'theoryConsumeProportion': '' // 自发自用比例率量
					// "utilityMeterDeviceId": 0,
					// "utilityStatisticMethod": "PROPORTION"
				},
				'station': {
					'contactPhone': '', // 联系电话
					// "createdBy": 0,
					 'createdDate': new Date(),
					// "creatorOrganizationId": 0,
					// "floorArea": 0,
					// "gridConnectedTime":new Date(),//并网时间
					startOperatingTime:new Date(lib.timeFormat(new Date(),"system","%Y/%m/%d")), // 投产日期
					'gridInterconnectionType': lib.getTypeText('', 'plantGridType', true)[0].id[0],
					// "id": 0,
					'installationAzimuthAngle': '', // 方位角
					'installationTiltAngle': '', // 倾角
					'installedCapacity': '', // 装机容量
					'location': {
						'address': '',
						'lat': null,
						'lng': null
						//						"lat":31.23611111111111,
						//						"lng":121.50222222222222
					},
					'name': '',
					// "ownerAccountId": 0,
					// "ownerRemark": "string",
					'region': {
						'nationId': null,
						'level1': null,
						'level2': null,
						'level3': null,
						'level4': null,
						'level5': null,
						'timezone': 'PRC'
					},
					'type': lib.getTypeText('', 'plantType', true)[0].id[0],
					// "valid": true
					"powerType":"PV"
				},
				custom: {
				}
			},
			currencyList: [], // 货币单位list
			dataDef: {}, // 原始数据
			dataBack: {}, // 可回退的数据
			otherData: {}, // 其它附加数据，会在新建完成事件中输出
			newPlantData: {}, // 新建的电站数据
			personList: [],
			deviceList: [], // 电站设备数据,1401130313,1401130314,1803540087
			// deviceListDef:[],
			deviceType: '',
			sensorCode: '',

			step: 1, // 当前步骤
			stepMax: 3, // 最大步骤数
			finishStepCount: 0, // 创建成功后动作的完成度
			timeLimit: [// 年限列表
				{text: 0, value: 0}, {text: 1, value: 1}, {text: 2, value: 2}, {text: 3, value: 3}, {text: 4, value: 4}, {text: 5, value: 5}, {text: 6, value: 6}, {text: 7, value: 7}, {text: 8, value: 8}, {text: 9, value: 9}, {text: 10, value: 10},
				{text: 11, value: 11}, {text: 12, value: 12}, {text: 13, value: 13}, {text: 14, value: 14}, {text: 15, value: 15}, {text: 16, value: 16}, {text: 17, value: 17}, {text: 18, value: 18}, {text: 19, value: 19}, {text: 20, value: 20}
			],
			timeLimit120: [// 年限列表-融资年限
				{text: 1, value: 1}, {text: 2, value: 2}, {text: 3, value: 3}, {text: 4, value: 4}, {text: 5, value: 5}, {text: 6, value: 6}, {text: 7, value: 7}, {text: 8, value: 8}, {text: 9, value: 9}, {text: 10, value: 10},
				{text: 11, value: 11}, {text: 12, value: 12}, {text: 13, value: 13}, {text: 14, value: 14}, {text: 15, value: 15}, {text: 16, value: 16}, {text: 17, value: 17}, {text: 18, value: 18}, {text: 19, value: 19}, {text: 20, value: 20}
			],
			timeZoneList: [],
			businessList: [],
			usersList: []
			// financeSwitch:true,//融资开关
		}
	},
	watch: {
	},
	methods: {
		getLanguageStr,
		getTypeText: lib.getTypeText,
    timeFormat: lib.timeFormat,
    statistic,
		changeC (index) {
			// console.log(this.data.finance.currency)
		},
		Close () { // 取消按钮后销毁组件 否则装机容量为0
			if(this.myMode=='new'){
				statistic('A23','A2302')
			}else{
				statistic('A24','A2402')
			}
			this.$refs.Window.hide()
		},
		reset: function (data, otherData) { // 初始化数据,data:{finance:{},metering:{},station:{}}
			if (this.myMode == 'new') {
				$.extend(true, this.data, this.dataBack, data)
				delete this.data.station.id// 删除id字段，否则报错
				this.subSysTagList = [] // 清空 添加子系统
				//Bliq平台创建电站优先余电上网-开发 (小麦商家版web1.4.0 )
				if (this.myMode == 'new' && this.stage.loc.customer == 'Bliq') {
					this.data.station.gridInterconnectionType =  lib.getTypeText('', 'plantGridType', true).filter(item=>item.value=="EXCESS")[0].id[0]
				}
			}
			if (otherData) $.extend(true, this.otherData, otherData)
			else this.otherData = {}
			// this.$refs.AddPerson.reset();//清空关联人数据
			$.each(this.$refs, function () { // 遍历范围内所有需要reset对象,以清除一些报错内容
				// trace(this);
				if (this && this.reset) this.reset()
			})
			if (data) {
				if ($.isNumeric(data.station.startOperatingTime)) {
					data.station.startOperatingTime = new Date(data.station.startOperatingTime * 1000)
				}
				if ($.isNumeric(data.station.createdDate)) {
					data.station.createdDate = new Date(data.station.createdDate * 1000)
				}
				if (data.finance != undefined) {
					data.finance.financingTerm = !data.finance.financingTerm ? null : new Date(data.finance.financingTerm * 1000)
				}
				this.targetId = data.station.id
				// this.targetId=id;
				$.extend(true, this.dataBack, data)
				$.extend(true, this.data, data);
			} else {
				this.targetId = null
			}
			lib.objTool(this.changeTip, 'allFalse')// 清空切换提示
			this.deviceList = []
			this.step = 1
			this.lock.newPlant = false

			// $("#newPlant .error").removeClass("error");
		},
		getCurencyList () {
			let $this = this
			let qc = {lan:stage.languageId}
			dictListCurrency(qc).then(function (success) {
				$this.currencyList = success
				if ($this.data.finance.currency == '') $this.data.finance.currency = success[0].code
			}, function (error) {
				!_.isEmpty(error) && $this.$notify(error)
			})
		},
		getTimeZoneList () {
			let $this = this
			let qc = {lan: stage.languageId}
			dictListTimezone(qc).then(success=>{
				let nowCode=this.data.station.region.timezone;
				$this.timeZoneList = success;
				this.$nextTick(()=>{
					this.data.station.region.timezone=nowCode;//select数据变更后会自动更新为第一条数据
				});
			}, function (error) {
				!_.isEmpty(error) && $this.$notify(error)
			})
		},
		/* 并网时间的限制 */
		disabledDate (time) {
			let day = time.getTime()
			return day > new Date().getTime()
		},
		startDate (time) {
			let day = time.getTime()
			return day < new Date('1970-01-01').getTime()
		},
		backToDefault: function (type) { // 还原为默认值
			switch (type) {
				case 'finance':
					this.data.finance.financingProportion = this.dataBack.finance.financingProportion
					this.data.finance.financingInterestRate = this.dataBack.finance.financingInterestRate
					this.data.finance.financingPeriod = this.dataBack.finance.financingPeriod
					this.data.finance.financingRepaymentMethod = this.dataBack.finance.financingRepaymentMethod
					this.data.finance.financingTerm = this.dataBack.finance.financingTerm
					break
				case '':
					break

				// case "":
				// 	break;
			}
		},
		newPlant: function (data, close = true, endFn) {
			this.lock.newPlant = true
			this.newPlantData = {}// 清空新电站数据
			this.$refs.AddPerson.reset()
			// this.$refs.AddDevice.reset();
			let $this = this
			// trace(data)

			let allClear = true
			$.each(this.$refs, function () {
				if (this && this.verification) { // 有时候某些组件隐藏掉会导致this为undefined
					let clear = this.doVerification()
					if (allClear) allClear = clear
				}
				// if(allClear==false) return false;
			})

			if (allClear) {
				let request = $.extend(true, {}, $this.data)
				// console.log(request)
				delete request.custom
				let param = null
				if (this.otherData.projectId) {
					param = {projectId: this.otherData.projectId}
					$this.targetId = ''
				}
				apiNewPlant(request, $this.targetId, param).then(function (success) {
					// trace(success,true);
					$this.newPlantData = success
					$this.targetId = success.id
					if (close) $this.close()
					$this.$emit('refresh', $this.targetId)
					if (endFn) endFn()

					$this.lock.newPlant = false
				}, function (error) {
					$this.lock.newPlant = false
					// alert(error);
					!_.isEmpty(error) && $this.$notify(error)
				})
				if (this.myMode == 'edit' && this.data.station.gridInterconnectionType != this.dataBack.station.gridInterconnectionType) { // 切换并网类型，设置自动数据来源
					StationMeteringStrategy(this.targetId, {strategy: 'DYNAMIC'})
				}
			} else {
				this.lock.newPlant = false
				// this.$refs.confirm.show({text:getLanguageStr('phrase538','请按要求填写表单内容')});
				// alert(getLanguageStr('phrase538','请按要求填写表单内容'));
				$this.$notify(getLanguageStr('phrase538', '请按要求填写表单内容'))
			}
		},
		newPlantFinish: function (canNext) { // 新建电站的最后一步操作，统计api执行完成数量后进行的操作
			if (canNext) {
				++this.finishStepCount
				if (this.finishStepCount == 2) {
					this.lock.newPlant = false
					this.$emit('AfterNew', {id: this.targetId}, this.otherData)
					this.close()
				}
			} else this.lock.newPlant = false
		},
		updatePosition: function (p, userAction){
			let data = _.cloneDeep(p)
			// trace(data,true)
			this.data.station.location.lng = data.lng
			this.data.station.location.lat = data.lat

			this.data.station.location.address = data.address

			this.data.station.region.nationId = data.lv1.id
			this.data.station.region.level1 = data.lv2.id
			this.data.station.region.level2 = data.lv3.id
			this.data.station.region.level3 = data.lv4.id
			this.data.station.region.level4 = data.lv5.id
			this.data.station.region.level5 = data.lv6.id

			// 用户操作的才保存
			// console.log(userAction , p.defaultCurrency)
			if (userAction && p.defaultCurrency) { this.data.finance.currency = p.defaultCurrency }
			if (userAction && p.defaultTimezone){
				this.data.station.region.timezone = p.defaultTimezone
			}
		},
		updateDeviceList: function (list, deviceType, sensorCode) {
			this.deviceList = list
			this.deviceType = deviceType
			this.sensorCode = sensorCode
		},
		updatePersonList (list) {
			this.personList = list
		},
		// 添加子系统
		_AddChildSys () {
			this.$refs.AddChildSys.modeChange('new')
			this.$refs.AddChildSys.show({id: this.targetId})
		},
		addChildSys (data) {
			let d = _.cloneDeep(data)
			this.subSysTagList.push(d)
		},
		deleteChildSys (tag, idx) {
			DeleteChildSys(tag.id).then(res => {
				this.subSysTagList = this.subSysTagList.filter((item, i) => i !== idx)
			}, error => {
				!_.isEmpty(error) && this.$notify(error)
			})
		},
		addDevice () { // 添加设备
			let command = _.cloneDeep(this.$refs.AddDevice.snList)
			if (command.length) {
				command.forEach(val => {
					delete val.modeChange
					delete val.defaultDiscovery
					if (val.autoDiscovery) {
						val.subDeviceIds = []
					}
				})
				PostGateway(this.targetId, {systemId: this.systemId}, command).then(res => {
				}, error => {
					!_.isEmpty(error) && this.$notify(error)
				})
			}
			// this.lock.newPlant=true;
			// let $this=this;
			// let request={
			// 	deviceType:this.deviceType,
			// 	sensorCode:this.sensorCode,
			// 	sns:this.deviceList
			// };
			// if(this.deviceList.length>0){
			// 	apiAddDevice(this.targetId,request).then(function(success){
			// 		$this.newPlantFinish(true);
			// 		//$this.getList();
			// 		// $this.$notify(getLanguageStr("phrase49+: ","添加成功：")+success.successCount);
			// 	},
			// 	function(error){
			// 		$this.newPlantFinish(false);
			// 		trace(error,true);
			// 		!_.isEmpty(error) && $this.$notify(error)
			// 	});
			// }else{
			// 	this.newPlantFinish(true);
			// }
		},
		addPerson: function () {
			this.lock.newPlant = true
			let $this = this
			let request = {
				stationIds: [this.targetId],
				watcherIds: this.personList
			}
			if (this.personList.length > 0) {
				apiAddPerson(request).then(function (success) {
					$this.newPlantFinish(true)
				},
				function (error) {
					$this.newPlantFinish(false)
					trace(error, true)
					!_.isEmpty(error) && $this.$notify(error)
				})
			} else {
				this.newPlantFinish(true)
			}
		},
		// 关联商家
		addBusiness () {
			if (this.businessList.length) {
				let entityRelIdList = this.businessList.map(el => el.entityRelId)
				let request = {
					entityRelIdList,
					stationIdList: [this.targetId]
				}
				AddRelatedBus(request).then(res => {
					this.newPlantFinish(true)
				}, error => {
					this.newPlantFinish(false)
					!_.isEmpty(error) && this.$notify(error)
				})
			}
		},
		// 关联用户
		addUser () {
			if (this.usersList.length) {
				let entityRelIdList = this.usersList.map(el => el.entityRelId)
				let request = {
					entityRelIdList,
					stationIdList: [this.targetId]
				}
				AddRelatedUser(request).then(res => {
					this.newPlantFinish(true)
				}, error => {
					this.newPlantFinish(false)
					!_.isEmpty(error) && this.$notify(error)
				})
			}
		},
		addFile: function (file, type) {
			switch (type) {
				case 'finance':
					this.data.finance.tariffUrl = file.file.src
					break
				case '':
					break
			}
		},
		removeFile: function (file, type) {
			switch (type) {
				case 'finance':
					this.data.finance.tariffUrl = ''
					break
				case '':
					break
			}
		},
		// nextStep:function(){
		// 	let $this=this;
		// 	switch(this.step){
		// 		case 1:
		// 			this.newPlant(this.data,(this.myMode=="new"?false:true),function(){
		// 				if($this.myMode=="new") ++$this.step;
		// 			});
		// 			break;
		// 		case 2:
		// 			this.addPerson(function(){
		// 				if($this.myMode=="new") ++$this.step;
		// 				else $this.close();
		// 			});
		// 			break;
		// 		case 3:
		// 			this.addDevice();
		// 			break;
		// 	}
		// },
		onStep: function () {
			if(this.myMode=='new'){
				if(this.step==1){
					statistic('A23','A2303')
				}else{
					statistic('A23','A2304')
				}
			}else {
				statistic('A24','A2403')
			}
			let buttonPermissions = JSON.parse(window.localStorage.getItem('buttonPermissions'))
			let $this = this
			switch (this.step) {
				case 1:
					this.newPlant(this.data, (this.myMode != 'new'), function () {
						if ($this.myMode == 'new') {
							if (buttonPermissions.includes('A/B/A16')) {
								$this.$refs.TagManageCore.show($this.targetId)
							}
							if (buttonPermissions.includes('A/B/A8')) {
								$this.AddContentsDevices()
								$this.$refs.AddDevice.reset({id: $this.targetId})// 清空设备数据
							}
							++$this.step
						} else $this.$emit('AfterEdit', $this.targetId, $this.otherData)
						setTimeout(function () {
							$('#newPlant>[scroll]').mCustomScrollbar('scrollTo', 'top')
						}, 200)
					})
					break
				case 2:
					this.finishStepCount = 0
					if (buttonPermissions.includes('A/B/A8')) {
						this.addDevice()
					}
					if (buttonPermissions.includes('A/B/A14')) {
						this.addPerson()
					}
					this.addBusiness()
					this.addUser()
					this.$refs.Window.hide()
					this.$emit('AfterNew', {id: this.targetId}, this.otherData)
					break
				case 3:
					break
			}
		},
		step2Skip () { // 取消第二步，下次再说
			if (this.tagList.length > 0) { // 需要还原处理标签
				let requestList = []
				$.each(this.tagList, function () {
					requestList.push(this.id)
				})
				apiDeleteTag(requestList, 1, this.targetId).then(success => {
					this.$refs.Window.hide()
					this.$emit('AfterNew', {id: this.targetId}, this.otherData)
				}, error => {
					this.$notify(error)
					this.$refs.Window.hide()
					this.$emit('AfterNew', {id: this.targetId}, this.otherData)
				})
			} else if (this.subSysTagList.length > 0) { // 需要还原处理子系统
				this.subSysTagList.forEach(el => {
					DeleteChildSys(el.id).then(res => {
					}, error => {
						!_.isEmpty(error) && this.$notify(error)
					})
				})
				this.$nextTick(() => {
					this.subSysTagList = []
					this.$refs.Window.hide()
					this.$emit('AfterNew', {id: this.targetId}, this.otherData)
				})
			} else { // 没有需要处理的
				this.$refs.Window.hide()
				this.$emit('AfterNew', {id: this.targetId}, this.otherData)
			}
		},
		showChangeTip (name) {
			switch (name) {
				case 'gridType':this.changeTip.gridType = true; break
			}
		},
		modeChange: function (mode, id, data) { // 切换模式
			// if(data){
			// 	data.station.startOperatingTime=new Date(data.station.startOperatingTime*1000);
			// 	data.finance.financingTerm=new Date(data.finance.financingTerm*1000);
			// 	this.targetId=data.station.id;
			// 	// this.targetId=id;
			// 	// $.extend(true,this.dataBack,data);
			// 	// $.extend(true,this.data,data);
			// }
			switch (mode) {
				case 'new':
					$.extend(true, this.dataBack, this.dataDef)
					this.myMode = mode
					this.targetId = ''
					break
				case 'edit':
					// $.extend(true,this.dataBack,data);
					this.myMode = mode;
					this.isEdit=true;
					this.targetId = id
					this.step = 1
					break
			}
			// this.$set(this,"myMode",mode);
		},
		open: function (data, otherData, isedit) {
			if (isedit) {
				this.isEdit = isedit
				statistic('A24','A2401')
			}else{
				statistic('A23','A2301')
			}
			let pass = false;
			if (this.myMode == 'new')pass = !!lib.doPermissions('A/B/A2');
			else if (this.myMode == 'edit') pass = !!lib.doPermissions('A/B/A3')
			if (pass) {
				this.reset(data, otherData)
				// this.$refs.SearchPosition.reset();
				// if(this.myMode=="edit"){//编辑模式才传入数据
				// 	StationMetering(this.targetId).then(//手动设置了数据来源，需要提醒
				// 		success=>{
				// 			// trace(success,true);
				// 			this.changeTip.sourceFrom=success.statisticMethodSettingStrategy=="DYNAMIC"?false:true;//STATIC
				// 		},
				// 		error=>{this.$notify(error);}
				// 	);
				// }
				let target
				if (data) {
					target = {
						lng:data.station.location.lng,
						lat:data.station.location.lat,
						address:data.station.location.address,
						region:data.station.region
					}
				}
				this.$refs.Window.show({end:()=>{
					this.$refs.SearchPosition.show(target)// 重置电站位置数据
				}})

				// console.log(this.data.finance.tariffUrl)
				// this.$nextTick(()=>{

				// });
			} else this.$notify(getLanguageStr('phrase783', '你没有权限，请联系本商家超级管理员开启'));
		},
		close: function () {
			this.$refs.Window.hide()
		},
		AddContentsDevices () {
			this.$refs.AddDevice.show({
				stationId: this.targetId
			})
		},
		returnStartOpTime:function(date){//处理投产日期，只要精确到年月日
			// this.data.station.startOperatingTime=new Date(lib.timeFormat(date,"utc","%Y/%m/%d",{offset:this.data.station.region.timezone}));
			this.data.station.startOperatingTime=lib.timeFormat(date,"targetZoneDate",{offset:this.data.station.region.timezone});
		}
	},
	created () {
		$.extend(true, this.dataDef, this.data)
		$.extend(true, this.dataBack, this.data)
	},
	computed: {
		progress: function () {
			// if(this.step)
			return Math.round((this.step - 1) / (this.stepMax - 1) * 100)
		},
		moreBtnFlag () {
			let buttonPermissions = JSON.parse(window.localStorage.getItem('buttonPermissions'))
			if (!buttonPermissions.includes('A/B/A14') && !buttonPermissions.includes('A/B/A8') && !buttonPermissions.includes('A/B/A16')) {
				return false
			} else {
				return true
			}
		},
		title: function () {
			switch (this.myMode) {
				case 'new':return getLanguageStr('cmd182', '添加新电站'); break
				case 'edit':return getLanguageStr('creat_plant3', '编辑电站'); break
			}
		},
		...mapGetters({
			// userFunctions:"user/userFunctions",
			// projectId: 'projectDetail/projectId'
		})
	},
	mounted () {
		this.reset()
		lib.fillHeight()
		lib.setScroll($('#newPlant [fillHeight][scroll]'))

		$('.quickNav>*').on('click', function () {
			let $scroll = $('#newPlant [fillHeight][scroll]')
			let top = $('#newPlant .tagForm').eq($(this).index()).position().top - 100
			if (top < 100) top = 0
			$scroll.mCustomScrollbar('scrollTo', top)
		})

		$.each($('.afterNew'), function () { // 处理操作权限，并提示
			if ($(this).hasClass('disable')) $(this).parent().attr('title', getLanguageStr('phrase783', '你没有权限，请联系本商家超级管理员开启'))
		});

		this.getCurencyList()// 获取货币单位列表
		this.getTimeZoneList()// 获取时区列表
	}
}
</script>
<style lang="scss" scoped>
.enableList{padding:0 .5em .5em 0;position:relative;}

tr>*{padding:{top:1em;bottom:1em;};}
.quickNav{width:10em;left:-12em;position:absolute;z-index:1;
	>*{width:100%;padding:{left:1em;right:1em;top:.5em;bottom:.5em;};display:block;text-align:right;font-size:1.2em;
		&:first-child{margin:{top:-.5em;};}
	}
}
</style>



// WEBPACK FOOTER //
// src/view/maintain/light/plant/part/New.vue